import { Logo, ThemeToggle, Button } from '@rr/ui'
import { APP_URL } from '../lib/links'

const NAV = [
  { href: '#concepts', label: 'Model' },
  { href: '#features', label: 'Mümkinçilikler' },
  { href: '#how', label: 'Iş akymy' },
  { href: '#examples', label: 'Mysallar' },
]

export function Header() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-8">
        {/* Left: logo + nav */}
        <div className="flex items-center gap-8 lg:gap-10 min-w-0">
          <a
            href="#top"
            aria-label="Route and Route"
            className="flex items-center gap-2.5 text-primary shrink-0"
          >
            <Logo tone="current" size={26} />
            <span className="font-semibold text-foreground tracking-tight text-[15px]">
              Route and Route
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-6 lg:gap-7 text-[15px] font-medium text-muted-foreground">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="hover:text-foreground transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Right: theme + CTA */}
        <div className="flex items-center gap-3 shrink-0">
          <ThemeToggle />
          <Button asChild className="hidden sm:inline-flex">
            <a href={APP_URL}>Programmany aç</a>
          </Button>
        </div>
      </div>
    </header>
  )
}
